import React from 'react';
import { CompleteProfileProvider } from '../../contexts/CompleteProfileContext';
import { Outlet } from '@tanstack/react-router';

const CompleteProfileLayout = () => {
  return (
    <CompleteProfileProvider>
      <Outlet />
    </CompleteProfileProvider>
  );
};

export default CompleteProfileLayout;
